export const locale = {
    lang: 'vn',
    data: {
        'NOW': "Bây giờ"
    }
};
